<template>
  <div id="dvDoruceniBox" v-show="zobrazVse">
    <div class="dvNadp">
      <h2>Kdy zboží obdržím?</h2>
      <span class="spkdy"
        ><strong>{{ typ_ppl_nadpis }}</strong></span
      >
    </div>
    <div class="dvBox">
      <div class="dvTypy" v-show="zobrazDostupnosti">
        <div>
          <span
            >Můžete osobně vyzvednout na prodejně Praha 9
            <strong>- {{ typ_prodejna }}</strong></span
          ><em v-html="odber_cena"></em>
        </div>
        <div>
          <span
            >Doručení na adresu v ČR kurýrem
            <strong>- {{ typ_ppl }}</strong></span
          ><em v-html="ppl_cena"></em>
        </div>
        <div v-show="zobrazDopstupnostProRecompDopravu" class="recomp">
          <span
            ><b>Přivezeme expresně po Praze</b>
            <strong>- {{ typ_recomp }}</strong></span
          ><em v-html="recomp_cena"></em>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Svatky } from "../class/Svatky.js";
import * as kosik from "../page/kosik.js";
import * as detail from "../page/detail.js";
/*
import * as moment from "moment";
import "moment/locale/cs";
*/
export default {
  name: "DoruceniBox",
  data() {
    return {
      typ_prodejna: "",
      typ_ppl: "",
      typ_ppl_nadpis: "",
      typ_recomp: "",
      odber_cena: "ZDARMA",
      ppl_cena: "ZDARMA",
      recomp_cena: "ZDARMA",
      zobrazDostupnosti: true,
      zobrazVse:true,
      zobrazDopstupnostProRecompDopravu:true
    };
  },
  /*
  computed: {
    typ_prodejna: function() {
      return "Ihned";
    },
    typ_ppl: function() {
      return "Ihned";
    },
    typ_recomp: function() {
      return "Ihned";
    }
  },
  */
  mounted() {
    this.zjistiDostupnost();
    this.zjistCenuDopravy();

    let $this = this;
    $(document).on("ladzo:zmenenaVarianta", function(e, myData) {
      Lc.e("doruceniBox.vue ladzo:zmenenaVarianta", [e, myData]);
      let P = myData.sklad[myData.id] || false;
      Lc.log('Produkt',P);
     // $this.nactiCenyProVariantu(myData);
     if(P.availabilityName=="Skladem"){
      $this.zobrazDostupnosti = true;
      $this.zobrazVse = true;
     }else{
      $this.zobrazDostupnosti = false;
      $this.zobrazVse = false;
     }

    });  

  },
  methods: {
    zjistCenuDopravy: function() {
      Lc.f("zjistCenuDopravy");

      var suma = kosik.kos_vratSumu() || 0;
      var cena = fce.get(detail.detailProduktu, "Product.priceWithVat") || 0;

      if (suma + cena < 2000) {
        this.odber_cena = '<em style="color:#70BA0D">ZDARMA</em>';
        this.ppl_cena = '<em style="color:#3689c0">89 Kč</em>';
        this.recomp_cena = '<em style="color:#3689c0">189 Kč</em>';
      }
    },
    zjistiDostupnost: function() {
      Lc.f("zjistiDostupnost");
      let stavSkladu;
      if(!detail.detailProduktu.maVarianty){
        stavSkladu = $("form#product-detail-form .availability-label")
        .text()
        .trim();
        if (stavSkladu != "Skladem") {
          this.zobrazDostupnosti = false;
          return false;
        }
      }
      

      //-------------prodejna
      //"2020-05-11 12:54"
      Svatky.vratVse().then(data => {
        Lc.promise("Svatky.vratVse",detail.detailProduktu.Product);
        let stav = false;

        let casDnes17 = Svatky.nastavCas(data.dnesMoment, "17:00");
        let casDnes10 = Svatky.nastavCas(data.dnesMoment, "10:00");
        let denVtydnu = data.dnesMoment.isoWeekday();
        let pondeli = Svatky.nastavDalsiDenVtydnu(data.dnesMoment, 7); //7 je pondeli
        let jePondeliSvatek = Svatky.overSvatek(pondeli);
        
        
        

        
        if(detail.jeMuProduct()){
          stav = "Obvykle do 24 hodin";
        }
        else if (data.dnesSvatek) {
          stav = " Dnes je státní svátek - máme zavřeno";
        } else if (data.dnesVikend && !jePondeliSvatek) {
          Lc.log("denVtydnu", denVtydnu);
          if (denVtydnu == 6) {
            stav = "nejdříve v pondělí " + pondeli.format("D.M.");
          } else {
            stav = "Zítra 10:00 - 17:00h";
          }
        } else if (data.dnesVikend) {
          stav = "Následující pracovní den";
        } else if (denVtydnu == 5 && data.dnesMoment.isAfter(casDnes17)) {
          stav = "nejdříve v pondělí " + pondeli.format("D.M.");
        } else if (data.dnesMoment.isAfter(casDnes17)) {
          if (data.zitraSvatek) {
            stav = "Následující pracovní den";
          } else {
            stav = "Zítra 10:00 - 17:00h";
          }
        } else if (data.dnesMoment.isBefore(casDnes10)) {
          stav = "Dnes 10:00 - 17:00h";
        } else {
          stav = "Ihned";
        }

        this.typ_prodejna = stav;
      });

      /*Každý všední den od 10:00 - 18:00h budeme zobrazovat - Ihned
V případě státního svátku automaticky naskočí - Dnes je státní svátek - máme zavřeno
Od páteční 18:00h do soboty 00:00 budeme zobrazovat -  nejdříve v pondělí 23.4 (aktuální datum)
Od Nedělní 00:00h do pondělní 00:00h budeme zobrazovat - Zítra 10:00 - 18:00h*/

      //----------ppl----------------
      //"2020-05-13 13:54"
      Svatky.vratVse().then(data => {
        //Lc.promise("Svatky.vratVse");
        let stav = false;

        let casDnes1330 = Svatky.nastavCas(data.dnesMoment, "13:30");
        
        if(detail.jeMuProduct()){
          stav = "Obvykle do 48 hodin";
        }
        else if (data.dnesSvatek) {
          stav = "Státní svátek - Odešleme v pracovní den";
        } else if (data.dnesVikend) {
          let pondeli = Svatky.nastavDalsiDenVtydnu(data.dnesMoment, 7); //7 je pondeli
          let jePondeliSvatek = Svatky.overSvatek(pondeli);
          if (jePondeliSvatek) {
            stav = "Odešleme následující pracovní den";
          } else {
            stav = "Odešleme v pondělí u Vás bude v úterý";
          }
        } else if (data.dnesMoment.isBefore(casDnes1330)) {
          if (data.zitraVikend || data.zitraSvatek) {
            stav = "Následující pracovní den";
          } else stav = "Už zítra";
        } else {
          if (data.zitraVikend || data.zitraSvatek) {
            stav = "Odešleme následující pracovní den";
          } else {
            let pozitri = Svatky.nastavDalsiDen(data.zitraMoment);
            if (Svatky.overVikend(pozitri) || Svatky.overSvatek(pozitri)) {
              stav = "Odešleme následující pracovní den";
            } else stav = "Pozítří " + pozitri.format("D.M.");
          }
        }

        //if(!data.dnesSvatek && !data.zitraSvatek &&  )
        //Lc.log("stav pro ppl", stav);
        //Lc.log("data - vracena", data);
        this.typ_ppl = stav;
      });

      //----------ppl do nadpisu----------------
      //"2020-05-13 13:54"
      Svatky.vratVse().then(data => {
        //Lc.promise("Svatky.vratVse");
        let stav = false;

        let casDnes1330 = Svatky.nastavCas(data.dnesMoment, "13:30");
        
        if(detail.jeMuProduct()){
          stav = "Obvykle do 48 hodin";
        }
        else if (data.dnesSvatek) {
          stav = "Státní svátek - Odešleme v pracovní den";
        } else if (data.dnesVikend) {
          let pondeli = Svatky.nastavDalsiDenVtydnu(data.dnesMoment, 7); //7 je pondeli
          let jePondeliSvatek = Svatky.overSvatek(pondeli);
          if (jePondeliSvatek) {
            stav = "Zboží odešleme následující pracovní den";
          } else {
            stav = "Zboží odešleme v pondělí u Vás bude v úterý";
          }
        } else if (data.dnesMoment.isBefore(casDnes1330)) {
          if (data.zitraVikend || data.zitraSvatek) {
            stav = "Zboží můžete mít následující pracovní den";
          } else
            stav =
              "Zboží můžete mít už zítra " + data.zitraMoment.format("D.M.");
        } else {
          if (data.zitraVikend || data.zitraSvatek) {
            stav = "Zboží odešleme následující pracovní den";
          } else {
            let pozitri = Svatky.nastavDalsiDen(data.zitraMoment);
            if (Svatky.overVikend(pozitri) || Svatky.overSvatek(pozitri)) {
              stav = "Zboží můžete mít následující pracovní den";
            } else stav = "Zboží můžete mít pozítří " + pozitri.format("D.M.");
          }
        }

        //if(!data.dnesSvatek && !data.zitraSvatek &&  )
        //Lc.log("stav pro ppl", stav);
        //Lc.log("data - vracena", data);
        this.typ_ppl_nadpis = stav;
      });

      /*
      Každý všední den do 13:00h zobrazujeme hodnotu:  Nejdříve zítra
Každý všední den od 13:00h zobrazujeme hodnotu:  Pozítří 24.4. (aktuální datum)
O víkendu budeme zobrazovat hodnotu: Odešleme v pondělí u Vás bude v úterý
Pokud bude státní svátek zobrazíme hodnotu: Státní svátek - Odešleme v pracovní den

*/
      //-----------recomp

      Svatky.vratVse().then(data => {
        //Lc.promise("Svatky.vratVse");
        let stav = false;

        let casDnes14 = Svatky.nastavCas(data.dnesMoment, "14:00");
        
       
        
        if(detail.jeMuProduct()){
          this.zobrazDopstupnostProRecompDopravu=false;
        }
        else if (data.dnesSvatek) {
          stav = "Státní svátek - Odešleme v pracovní den";
        } else if (data.dnesSvatek || data.dnesVikend) {
          stav = "Po telefonické dohodě";
        } else if (data.dnesMoment.isBefore(casDnes14)) {
          stav = "Už dnes v čase 15:00-20:00h";
        } else if (data.zitraSvatek) {
          stav = "Po telefonické dohodě";
        } else {
          stav = "Dovezeme zítra v čase 15:00-20:00h";
        }

        //if(!data.dnesSvatek && !data.zitraSvatek &&  )
        //Lc.log("stav pro recomp", stav);
        //Lc.log("data - vracena", data);
        this.typ_recomp = stav;
      });
    }
  }
};
</script>
<style lang="less"></style>
